var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.615234 7.92969C0.615234 8.27148 0.761719 8.61328 1.00586 8.85742L7.41211 15.2441C7.67578 15.5078 7.97852 15.6348 8.29102 15.6348C9.01367 15.6348 9.52148 15.127 9.52148 14.4434C9.52148 14.0723 9.36523 13.7793 9.14062 13.5449L6.93359 11.3281L4.45312 9.05273L6.65039 9.17969H18.0957C18.8574 9.17969 19.375 8.67188 19.375 7.92969C19.375 7.1875 18.8574 6.67969 18.0957 6.67969H6.65039L4.45312 6.79688L6.93359 4.53125L9.14062 2.30469C9.375 2.07031 9.52148 1.77734 9.52148 1.40625C9.52148 0.732422 9.01367 0.214844 8.29102 0.214844C7.97852 0.214844 7.67578 0.341797 7.39258 0.615234L1.00586 7.00195C0.761719 7.23633 0.615234 7.58789 0.615234 7.92969Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.45d029247ca3b360259f2b0653e41242.svg";
export { ForwardRef as ReactComponent };